const gotToPageColor = '#999'

const paginationCss = {
    paginationInput: {
        width: '12em',
        "& input": {
            fontSize: "12px",
            color: gotToPageColor,
            fontWeight: 400
        }
    },

}

export default paginationCss;